import CompetenciesPage from './CompetenciesPage';
export default CompetenciesPage;